import http from '@/utils/Http';
import Vue from 'vue';

const BASE_PATH = '/v1/market_places';

const loadEntries = (params) => {
    return new Promise((resolve, reject) => {
        const p = new URLSearchParams(params);
        http.get(`${BASE_PATH}?${p.toString()}`)
            .then(({data}) => resolve(data))
            .catch(reject);
    })
};

export default {
    namespaced: true,
    state: {
        sellers: {},
        buyers: {},
        lastUpdate: null,
    },
    getters: {
        sellers: state => state.sellers,
        buyers: state => state.buyers,
        lastUpdate: state => state.lastUpdate,
    },
    mutations: {
        setEntries(state, entries) {
            if (entries) {

                const newState = {
                    sellers: {},
                    buyers: {}
                };

                entries.forEach(e => {
                    newState[e.is_seller ? 'sellers' : 'buyers'][e.id] = e;
                    if (!state.lastUpdate) state.lastUpdate = e;

                    if (new Date(state.lastUpdate.updated_at).getTime() < new Date(e.updated_at).getTime()) {
                        state.lastUpdate = e;
                    }
                });

                Vue.set(state, 'sellers', newState.sellers);
                Vue.set(state, 'buyers', newState.buyers);
            }
        },
        addUpdateEntry(state, entry) {
            if (entry && entry.id)
                Vue.set(state[entry.is_seller ? 'sellers' : 'buyers'], entry.id, entry);
        },
        removeEntry(state, id) {
            if (state.buyers[id]) Vue.delete(state.buyers, id);
            else if(state.sellers[id]) Vue.delete(state.sellers, id);
        },
        setLastUpdate(state, payload) {
            state.lastUpdate = payload;
        }
    },
    actions: {
        async filter({commit}, params) {
            return new Promise((resolve, reject) => {
                loadEntries(params)
                    .then(data => {
                        commit('setEntries', data);
                        resolve(data);
                    })
                    .catch(reject);
            })
        },
        async save({commit}, payload) {
            return new Promise((resolve, reject) => {
                if (payload.id) {
                    http.put(`${BASE_PATH}/${payload.id}`, {market_place: payload})
                        .then(({data}) => {
                            commit('addUpdateEntry', data);
                            commit('setLastUpdate', data);
                            resolve(data)
                        })
                        .catch(reject);
                } else {
                    http.post(BASE_PATH, {market_place: payload})
                        .then(({data}) => {
                            commit('addUpdateEntry', data);
                            resolve(data)
                        })
                        .catch(reject);
                }
            })
        },
        async load({commit}, id) {
            return new Promise((resolve, reject) => {
                http.get(`${BASE_PATH}/${id}`)
                    .then(({data}) => {
                        resolve(data);
                    })
                    .catch(reject);
            })
        },
        async destroy({commit}, id) {
            return new Promise((resolve, reject) => {
                http.delete(`${BASE_PATH}/${id}`)
                    .then(({data}) => {
                        commit('removeEntry', id);
                        resolve(data);
                    })
                    .catch(reject);
            })
        }
    }
}
